import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { formatDate } from 'App/components/PatientProfile/PatientProfile.utils';
import CMSService from 'App/services/CMSService';
import { dateTimeSlashesFormat } from 'App/services/DateService';

export const useFetchContentGroups = (type, filterParams) => {
    const query = useQuery(
        ['contentList', type, JSON.stringify(filterParams)],
        () => CMSService.getContentGroups(type, { unpublished: true, ...filterParams }),
        {
            enabled: !!type,
            staleTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: false,
            keepPreviousData: true,
        }
    );

    const formattedData = useMemo(
        () =>
            Object.values(query.data?.results ?? {})
                .map((i) => {
                    const updatedByUser =
                        i.updatedByUser?.firstName && i.updatedByUser?.lastName
                            ? {
                                  ...i.updatedByUser,
                                  fullName: `${i.updatedByUser.lastName}, ${i.updatedByUser.firstName}`,
                              }
                            : i.updatedByUser;

                    return {
                        ...i,
                        updatedOn: i.updatedOn ? formatDate(i.updatedOn, dateTimeSlashesFormat) : i.updatedOn,
                        updatedByUser,
                    };
                }),
        [query.data?.results]
    );

    return {
        ...query,
        data: formattedData,
        totalCount: query.data?.total,
    };
};

export default useFetchContentGroups;
